"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const styled_components_1 = __importStar(require("styled-components"));
const tokens = __importStar(require("@trp-rps-rps-shared-web/rps-shared-web-styles"));
const StyledContainer = styled_components_1.default.div `
  position: relative;
  margin: 8px 0px 8px 0px;
  outline: none;
  @media only screen and (max-width: 768px) {
    width: 100%;
  }
`;
const DropdownHeader = styled_components_1.default.div `
  border-radius: 4px;
  border: ${props => (props.textDropdown ? "none" : "1px solid")};
  width: ${props => (props.width ? props.width + "px" : "auto")};
  border-color: ${props => props.hasError ? tokens.ColorFunctionalRed700 : tokens.ColorGrey500};
  background-color: ${props => props.textDropdown ? "transparent" : tokens.ColorWhite000};
  padding: ${props => (props.textDropdown ? "8px 8px" : "8px 16px")};
  font-family: Nimbus Sans Regular;
  font-size: 16px;
  line-height: 22px;
  color: ${props => (props.textColor ? props.textColor : '#3b4b59')};
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 40px;
  @media only screen and (max-width: 768px) {
    height: 48px;
  }
  &:hover {
    border-color: ${props => props.textDropdown ? "white" : tokens.ColorBrandBrightBlue};
  }
  ${(props) => props.active &&
    styled_components_1.css `
      border-color: ${tokens.ColorBrandBrightBlue};
    `};
`;
const DropdownIcon = styled_components_1.default.img `
  padding-left: 8px;
`;
const DropdownOptionsContainer = styled_components_1.default.ul `
  border-radius: 4px;
  border: 1px solid ${tokens.ColorWhite200};
  box-shadow: 0 4px 4px 0 rgba(45, 57, 64, 0.08),
    0 0 2px 0 rgba(45, 57, 64, 0.12);
  max-height: 175px;
  overflow-y: auto;
  overflow-x: hidden;
  scrollbar-width: thin;
  scrollbar-color: ${tokens.ColorWhite100};
  z-index: 3;
  position: absolute;
  top: 40px;
  background-color: white;
  min-width: ${props => (props.width ? parseInt(props.width) + "px" : "auto")};
  list-style-position: inside;
  padding-left: 0;
  &::-webkit-scrollbar {
    width: 10px;
  }
  &::-webkit-scrollbar-track {
    background: ${tokens.ColorWhite000};
  }
  &::-webkit-scrollbar-thumb {
    background-color: ${tokens.ColorWhite100};
    border-radius: 4px;
    border: 1px solid ${tokens.ColorWhite000};
  }
  @media only screen and (max-width: 768px) {
    width: 100%;
  }
`;
const DropdownOptionsItem = styled_components_1.default.li `
  display: block;
  padding: 8px 16px;
  font-family: Nimbus Sans Regular;
  font-size: 16px;
  cursor: pointer;
  color: ${tokens.ColorGrey800};
  white-space: nowrap;

  &:hover {
    background-color: ${tokens.ColorWhite050};
  }
  &:first-of-type {
    margin-top: 8px;
  }
  &:last-of-type {
    margin-bottom: 8px;
  }
`;
const StyledError = styled_components_1.default.div `
  font-size: 14px;
  font-family: Nimbus Sans Regular;
  color: ${tokens.ColorFunctionalRed700};
  width: ${props => (props.width ? props.width + "px" : "auto")};
  margin-top: 8px;
`;
class Dropdown extends react_1.Component {
    constructor(props) {
        super(props);
        this.openMenu = () => {
            this.setState({ menuIsOpen: true }, () => {
                document.addEventListener("click", this.closeMenu);
            });
        };
        this.closeMenu = () => {
            this.setState({ menuIsOpen: false }, () => {
                document.removeEventListener("click", this.closeMenu);
            });
        };
        this.selectOption = (option) => {
            const { onChange } = this.props;
            onChange(option);
        };
        this.keyDownOpenMenu = (e) => {
            const { menuIsOpen } = this.state;
            let code = e.key;
            if (code === 'Enter' || code === ' ') {
                this.setState({ menuIsOpen: menuIsOpen ? false : true });
            }
        };
        this.keyDownOption = (e, option) => {
            const { onChange } = this.props;
            let code = e.key;
            if (code === 'Enter' || code === ' ') {
                //alert("Test: " + option.value);
                onChange(option);
            }
        };
        this.state = {
            selectedOption: {},
            menuIsOpen: false
        };
    }
    render() {
        const { label, options, onChange, selectedOption, width, errorMessage, arrowStyle, textColor, textDropdown, className, id, } = this.props;
        const { menuIsOpen } = this.state;
        return (react_1.default.createElement(StyledContainer, { className: className },
            react_1.default.createElement(DropdownHeader, { onClick: this.openMenu, active: menuIsOpen, hasError: errorMessage, textDropdown: textDropdown, textColor: textColor, width: width, "aria-label": `${label} dropdown`, role: "button", "aria-haspopup": "listbox", "aria-expanded": menuIsOpen, tabIndex: 0, onKeyPress: this.keyDownOpenMenu, id: id + '-header' },
                react_1.default.createElement("div", { id: id + '-selected' }, selectedOption.name || label),
                react_1.default.createElement(DropdownIcon, { alt: "Select option dropdown arrow", src: menuIsOpen
                        ? `data:image/svg+xml;base64,${arrowStyle === "blue"
                            ? tokens.AssetIconDropdownUpArrowBlue
                            : tokens.AssetIconDropdownUpArrow}`
                        : `data:image/svg+xml;base64,${arrowStyle === "blue"
                            ? tokens.AssetIconDropdownDownArrowBlue
                            : tokens.AssetIconDropdownDownArrow}` })),
            !menuIsOpen && errorMessage && (react_1.default.createElement(StyledError, null, errorMessage)),
            menuIsOpen ? (react_1.default.createElement(DropdownOptionsContainer, { width: width, textDropdown: textDropdown, "aria-label": "Dropdown List", role: "listbox", tabIndex: -1 }, options.map(option => (react_1.default.createElement(DropdownOptionsItem, { onClick: () => onChange(option), tabIndex: 0, value: option.value, key: option.value, id: option.id, role: "option", onKeyPress: (e) => this.keyDownOption(e, option) }, option.name))))) : null));
    }
}
exports.default = Dropdown;
//# sourceMappingURL=Dropdown.js.map